import { sva } from '@news/styled-system/css'

export const carouselPostRecipe = sva({
    slots: ['cardBody', 'cardImage', 'titleHeading', 'titleLink'],
    base: {
        cardBody: {
            minHeight: '[90px]',
        },
        cardImage: {
            height: '[200px]',
            objectFit: 'cover',
        },
        titleHeading: {
            fontSize: '[1rem]',
            fontFamily: '[inherit]',
            fontWeight: 'bold',
            color: '[#888]',
            wordBreak: 'break-word',
            lineClamp: 2,
            lineHeight: '[1.5]',
            maxHeight: '[3em]',
            _last: {
                marginBottom: '0',
            },
        },
        titleLink: {
            color: '[inherit]',
            _hover: {
                textDecoration: 'none',
            },
        },
    },
})
